/**
 * A prompt typed on the public home page before signing in. Saved when the
 * visitor is sent to /login and restored into the prompt when they return,
 * so the sign-in detour does not eat what they wrote. sessionStorage: it
 * belongs to this tab only and should not outlive it.
 */
const KEY = "paperclip:draft-prompt";

export const saveDraftPrompt = (text: string) => {
  try {
    if (text) sessionStorage.setItem(KEY, text);
  } catch {
    // Private mode / disabled storage: the draft is simply lost.
  }
};

/** Read and clear the saved draft (one-shot). */
export const takeDraftPrompt = (): string | null => {
  try {
    const value = sessionStorage.getItem(KEY);
    if (value) sessionStorage.removeItem(KEY);
    return value;
  } catch {
    return null;
  }
};
